export default "__VITE_ASSET__APpFGImL__"